// extracted by mini-css-extract-plugin
export default {"rowAdditional":"products_rowAdditional__E4f2A","headerAdditional":"products_headerAdditional__sSIC4","searchAdditional":"products_searchAdditional__EiphO"};